export interface AccordionOptions {
	el: string | NodeListOf<HTMLElement>
	trigger?: string
	showOne?: boolean
	firstOpen?: boolean
	activeClass?: string
	onOpen?: (el: HTMLElement, index: number) => void
	onClose?: (el: HTMLElement, index: number) => void
}

export default class Accordion {
	protected el: NodeListOf<HTMLElement>
	protected trigger: string | null
	protected showOne?: boolean
	protected firstOpen?: boolean
	protected activeClass: string
	protected onOpen?: (el: HTMLElement, index: number) => void
	protected onClose?: (el: HTMLElement, index: number) => void

	constructor(options: AccordionOptions) {
		this.el =
			typeof options.el === 'string'
				? (document.querySelectorAll(
						options.el
					) as NodeListOf<HTMLElement>)
				: options.el

		this.trigger = options.trigger ?? null
		this.showOne = options.showOne
		this.firstOpen = options.firstOpen
		this.activeClass = options.activeClass ?? 'accordion-el__open'
		this.onOpen = options.onOpen
		this.onClose = options.onClose

		this.handleToggle();
	}

	protected handleToggle(): void {
		if (!this.el || this.el.length === 0 || !this.trigger) {
			throw new Error('Accordion "el" is not defined or not found')
		}

		if (this.firstOpen) {
			this.open(this.el[0], 0)
		}

		this.el.forEach((element, index) => {
			if (!this.trigger) return

			const trigger = element.querySelector<HTMLElement>(this.trigger);

			trigger?.addEventListener('click', () => {
				const isOpen = element.classList.contains(this.activeClass)

				if (this.showOne) {
					if (isOpen) {
						return this.close(element, index)
					}

					const siblings = Array.from(this.el).filter(
						(sibling) => sibling !== element
					)
					siblings.forEach((sibling, siblingIndex) => this.close(sibling, siblingIndex))
					this.open(element, index)
				} else {
					if (isOpen) {
						this.close(element, index)
					} else {
						this.open(element, index)
					}
				}
			})
		})
	}

	public open(el: HTMLElement, index: number): void {
		if (el.classList.contains(this.activeClass)) return
		el.classList.add(this.activeClass)
		this.onOpen?.(el, index)
	}

	public close(el: HTMLElement, index: number): void {
		if (!el.classList.contains(this.activeClass)) return
		el.classList.remove(this.activeClass)
		this.onClose?.(el, index)
	}
}
